import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StaticsComponent } from './statics.component';
import { PrivacyComponent } from './privacy/privacy.component';


const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaticsRoutingModule { }
